var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.01985 12.5634C6.89801 11.086 9.96003 8.02399 11.4374 4.14582C12.9148 8.02399 15.9768 11.086 19.855 12.5634C15.9768 14.0408 12.9148 17.1028 11.4374 20.9809C9.96003 17.1028 6.89801 14.0408 3.01985 12.5634Z",
    stroke: "white",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0777 3.18717C22.1362 3.63386 21.3183 4.42202 20.7926 5.27186C20.3666 4.37129 19.6414 3.57866 18.6947 3.11386C19.5838 2.64966 20.3514 1.87544 20.8499 0.998152C21.3185 1.93281 22.1362 2.73766 23.0777 3.18717Z",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarsIcon);
export default __webpack_public_path__ + "static/media/starsIcon.d5c81a477d887af5ab0c664b33245689.svg";
export { ForwardRef as ReactComponent };